exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".highlighted{\n  border-radius: 4px;\n  background: #788990;\n};", "", {"version":3,"sources":["src/components/Sidebar/Sidebar.css"],"names":[],"mappings":"AAAA;EACE,mBAAkB;EAClB,oBAAmB;CACrB,CAAA","file":"Sidebar.css","sourcesContent":[".highlighted{\n  border-radius: 4px;\n  background: #788990;\n};"],"sourceRoot":""}]);

// exports
